import HowPlayBlock from '../components/HowPlay';

const HowPlay = () => {
  return (
    <HowPlayBlock />
  )
};

export default HowPlay;